var map = {
	"./asterisk.svg": 6235,
	"./chat.svg": 3058,
	"./clouds.svg": 1511,
	"./exclamation.svg": 353,
	"./facebook.svg": 1693,
	"./home.svg": 2781,
	"./instagram.svg": 2770,
	"./phone.svg": 6289,
	"./whatsapp.svg": 8651
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 968;